import { MCause } from './cause.model';
import { Cause } from '../interfaces/treatment';

export class MCauseArray{
    public causes: MCause[] = [];

    constructor(causes: Cause[]){
        if (causes) {
            causes.forEach(cause => {
                this.causes.push(new MCause({regular:cause}))
            });
        }
    }
}